import React from 'react';
import '../../../../Stylesheets/Dashboard/AnalyticsPreview.css';

const AnalyticsPreview = () => {
  const topMaterials = [
    { name: 'Cement', unit: 300 },
    { name: 'Steel', unit: 300 },
    { name: 'Bricks', unit: 300 },
  ];

  return (
    <div className="analytics-wrapper">
      <h3 className="section-title">Analytics</h3>

      <div className="analytics-mini-cards">
        <div className="mini-card log">
          <div className="bars">
            <div className="mini-bar bar-1"></div>
            <div className="mini-bar bar-2"></div>
            <div className="mini-bar bar-3"></div>
            <div className="mini-bar bar-4"></div>
            <div className="mini-bar bar-5"></div>
          </div>
          <p>Log entries this week</p>
        </div>

        <div className="mini-card expense">
          <div className="bars">
            <div className="mini-bar bar-5"></div>
            <div className="mini-bar bar-4"></div>
            <div className="mini-bar bar-3"></div>
            <div className="mini-bar bar-2"></div>
            <div className="mini-bar bar-1"></div>
          </div>
          <p>Expense this week</p>
        </div>

      </div>

      <div className="top-materials">
        <h4 className="materials-title">Top Used Material</h4>
        <ul className="material-list">
          {topMaterials.map((item, index) => (
            <li key={index} className="material-item">
              <span>{item.name}</span>
              <span>{item.unit} Unit</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default AnalyticsPreview;
